import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useUserStore } from "@store/user";
import { useAcceptCredacChange, useGetCurrentCsobCompanyInfo } from "@api";
import { ConfirmationModal } from "@components/common";

interface CredacChangeModal {}

const CredacChangeModal: FC<CredacChangeModal> = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const { user } = useUserStore();
  const { acceptCredacChangeAsync, isPendingAcceptCredacChange } =
    useAcceptCredacChange(user);
  const { currentCsobCompanyInfo } = useGetCurrentCsobCompanyInfo(user);

  const handleAcceptCredacChange = async (): Promise<void> => {
    await acceptCredacChangeAsync();
    setIsOpen(false);
  };

  useEffect(() => {
    if (user && currentCsobCompanyInfo?.credacCodeChanged) {
      setIsOpen(true);
    }
  }, [currentCsobCompanyInfo, user]);

  return (
    <ConfirmationModal
      open={isOpen}
      onClose={() => {}}
      onConfirm={handleAcceptCredacChange}
      title={t("csob.hub.credacChange.title")}
      description={t("csob.hub.credacChange.description")}
      confirmText={t("csob.hub.credacChange.continue")}
      noCancel={true}
      isLoading={isPendingAcceptCredacChange}
    />
  );
};

export default CredacChangeModal;
